import { Directive, ElementRef, AfterViewInit, HostListener } from '@angular/core'

@Directive({
  selector: 'textarea[appAutoResize]',
  standalone: true,
})
export class AutoResizeDirective implements AfterViewInit {
  constructor(private el: ElementRef<HTMLTextAreaElement>) {}

  ngAfterViewInit(): void {
    this.resize()
  }

  @HostListener('input')
  onInput(): void {
    this.resize()
  }

  private resize(): void {
    const textarea = this.el.nativeElement
    textarea.style.overflowY = 'hidden'
    textarea.style.height = 'auto'
    textarea.style.height = textarea.scrollHeight + 'px'
  }
}
